import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['inputSource']

  select(event) {
    const selectedInputSource = event.currentTarget.dataset.inputSource
    this.inputSourceTarget.value = selectedInputSource
  }
}
